export type IconSize = 'base' | 'lg';

export type IconColorType =
    | 'bookKeeping'
    | 'bookmark'
    | 'calendar'
    | 'catalogue'
    | 'company'
    | 'documents'
    | 'help'
    | 'home'
    | 'message'
    | 'MLDocument'
    | 'PDF'
    | 'purchases'
    | 'receipt'
    | 'report'
    | 'settings'
    | 'team'
    | 'user'
    | 'ZIP';

export type Color = 'black' | 'green' | 'grey';

export const COLOR: Record<Color, string> = {
    black: 'text-grey-900',
    green: 'text-green-700',
    grey: 'text-grey-400',
};
